/*
 * 오전 6시 ~ 자정(밤 12시) 사이가 아니면(즉, 오전 6시 미만 또는 자정 이후면) 홈택스 조회 불가
 * */
export const checkHometaxAvailableTime = () => {
  const hours = new Date().getHours();
  return hours >= 6;
};
